/**
 * Created by csi0n on 20/01/2017.
 */
var meeting_common = {
    tools: {
        toast: function (obj) {
            layer.msg(obj.message);
        },
        load: function () {
            return layer.load(1, {
                shade: [0.2, '#fff'] //0.1透明度的白色背景
            });
        }
    },
    AJAX: {
        request: function (obj) {
            var _default = {
                beforeSend: function () {
                    meeting_common.tools.load();
                },
                error: function (request) {
                    var toast = '';
                    switch (request.status) {
                        case 422:
                            $.each(JSON.parse(request.responseText), function (i, val) {
                                $.each(val, function (k, v) {
                                    toast += v;
                                });
                            });
                            break;
                        case 500:
                            toast = "服务器内部错误";
                            break;
                        case 429:
                            toast = "请求次数过多";
                            break;
                        default:
                            break;
                    }
                    meeting_common.tools.toast({
                        message: toast
                    });
                },
                complete: function () {
                    layer.close(meeting_common.tools.load());
                }
            };
            $.ajax($.extend(obj, _default));
        },
    },
    form: {
        callback: function (obj) {
            var _default = {
                beforeSend: function () {
                    meeting_common.tools.load();
                },
                error: function (request) {
                    var toast = '';
                    switch (request.status) {
                        case 422:
                            $.each(JSON.parse(request.responseText), function (i, val) {
                                $.each(val, function (k, v) {
                                    toast += v;
                                });
                            });
                            break;
                        case 500:
                            toast = "服务器内部错误";
                            break;
                        case 429:
                            toast = "请求次数过多";
                            break;
                        default:
                            break;
                    }
                    meeting_common.tools.toast({
                        message: toast
                    })
                },
                complete: function () {
                    layer.close(meeting_common.tools.load());
                }
            };
            return $.extend(obj, _default);
        }
    }
};